module.exports = __webpack_public_path__ + "img/IMG_0475.09b5cc14.jpg";